
export enum TransitionStepsText {
  ENTRY = 'Estamos analizando el presupuesto, así ahorrarás tiempo en los próximos pasos.',
  NFC_APP = 'Estamos guardando los datos del documento, en unos segundos podrás revisarlos.',
  OCR = 'Estamos guardando los datos del documento',
  PERSONAL_DATA = 'Guardando datos de cliente, sólo quedan unos segundos.',
  DE_DEC = 'Estamos revisando la solicitud, en breve te mostraremos cómo continuar.',
  COUNTER_OFFER = 'Estamos actualizando la solicitud, danos unos segundos.'
}
